import { generateUrl } from "@nextcloud/router";
const getAvatarUrl = (user, size, isGuest) => {
  const darkTheme = window.getComputedStyle(document.body).getPropertyValue("--background-invert-if-dark") === "invert(100%)";
  return generateUrl("/avatar" + (isGuest ? "/guest" : "") + "/{user}/{size}" + (darkTheme ? "/dark" : ""), {
    user,
    size
  });
};
export {
  getAvatarUrl as g
};
//# sourceMappingURL=getAvatarUrl-DxvUjKMi.mjs.map
